var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from "react";
import { useLookupInfoContext } from "@costar-search-x/core";
export function connectToSearchCriteriaWithLookupInfo(mapCriteriaToProps, mapUpdateCriteriaToProps, filterId) {
    return function Connect(WrappedComponent) {
        return function Connect(_a) {
            var criteria = _a.criteria, updateCriteria = _a.updateCriteria, props = __rest(_a, ["criteria", "updateCriteria"]);
            var context = useLookupInfoContext();
            var modifyCriteria = useCallback(function (criteria, options, bounds, position) {
                updateCriteria(criteria, options, filterId, bounds, position);
            }, [updateCriteria]);
            return (React.createElement(WrappedComponent, __assign({}, props, mapCriteriaToProps(criteria, context === null || context === void 0 ? void 0 : context.getLookupInfo), mapUpdateCriteriaToProps(modifyCriteria, context === null || context === void 0 ? void 0 : context.updateLookupInfo))));
        };
    };
}
//# sourceMappingURL=connect-to-search-criteria-with-lookup.js.map